export default __webpack_public_path__ + "static/media/mobile11.05de3412.jfif";